<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import Loading from "@/components/table-loading";
import ConfirmDelete from "@/components/table/confirm-delete-popover";
import { viewItem, deleteItem } from "@/helpers/crud-func";
import appConfig from "@/app.config";
import ICountUp from "vue-countup-v2";
/*
 *  Chat History component
 */
export default {
  page: {
    title: "Chat History",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
    ConfirmDelete,
    ICountUp,
  },
  data() {
    return {
      // page header
      title: "Chat History",
      items: [],
      // crud functions
      fetchLink: appConfig.chat_history.list,
      fetchLinkById: appConfig.chat_history.listById,
      viewRouteName: "View-Chat",
      deleteLink: appConfig.chat_history.delete,
      componentData: [],
      // table properties
      transProps: {
        name: "table-list",
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortDesc: false,
      hover: true,
      isBusy: true,
      start_date : "",
      end_date : "",
      fields: [
        {
          key: "id",
          label: "id",
          sortable: true,
        },
        {
          key: "admin",
          label: "Agent Name",
        },
        {
          key: "user.name",
          label: "User Name",
        },
        {
          key: "started_at",
          label: "Contacted At",
        },
        {
          label: "Ended At",
          key: "finished_at",
        },
        {
            key:"isSolved",
            label:"Solved?"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
      fetchAdminLink: appConfig.admins.list,
      adminList: [],
      selectedAdmin: null,
      startAverageTime: 0,
      respondAverageTimeUser: 0,
      respondAverageTimeAgent: 0,
      total: 0,
      endAverageTime: 0,
      delay: 3000,
      options: {
        useEasing: true,
        useGrouping: true,
      },
    };
  },

  computed: {
    rows() {
      return this.componentData.length; // Total no. of records
    },
  },
  methods: {
    async viewItem(item, viewRouteName) {
      // let routeData = this.$router.resolve({
      //   name: '/print-chat/',
      //   params: {
      //     id: item.id,
      //   },
      // });
      window.open("/print-chat/" + item.id, "_blank");
    },
    //List of Admins
    async fetchAdminList() {
      let that = this;
      let url = `${that.fetchAdminLink}`;
      let sessionUrl = `${that.fetchLink}`;
      that.isBusy = true;
      await axios.get(url).then(function (response) {
        that.adminList = response.data.admins;
        that.startAverageTime = response.data.starting_time_avreage;
        that.respondAverageTimeUser = response.data.replying_time_average_user;
        that.respondAverageTimeAgent = response.data.replying_time_average_agent;
        that.total = response.data.total;
        that.endAverageTime = response.data.conversation_times_avearge;
      });
      await axios.get(sessionUrl).then(function (response) {
        that.componentData = response.data.data;
      });
      that.isBusy = false;
    },
    async fetchComponentData() {
        let that = this;
        let url = `${that.fetchLink}`;
        let urlById = `${that.fetchLinkById}`;
        that.isBusy = true;
        if (this.selectedAdmin === null || this.selectedAdmin === "") {
            that.fetchAdminList();
        }else {
            axios.get(`admins/${that.selectedAdmin}/sessions` + '?from=' + that.start_date + '&to=' + that.end_date).then(function (response) {
              that.componentData = response.data.data;
              that.startAverageTime = response.data.starting_time_avreage;
              that.respondAverageTimeUser = response.data.replying_time_average_user;
              that.respondAverageTimeAgent = response.data.replying_time_average_agent;
              that.total = response.data.total;
              that.endAverageTime = response.data.conversation_times_avearge;
              that.isBusy = false;
           }); 
        }
        
    },
    onChangeSelect(event) {
      let that = this;
      axios.get(`admins/${that.selectedAdmin}/sessions` + '?from=' + that.start_date + '&to=' + that.end_date).then(function (response) {
        that.componentData = response.data.data;
        that.startAverageTime = response.data.starting_time_avreage;
        that.respondAverageTimeUser = response.data.replying_time_average_user;
        that.respondAverageTimeAgent = response.data.replying_time_average_agent;
        that.total = response.data.total;
        that.endAverageTime = response.data.conversation_times_avearge;
      });
    },
    printChat(){
      window.print();
    }
  },
  created() {
    this.deleteItem = deleteItem.bind(this);
    
  },
  mounted() {
    this.fetchAdminList();
    this.fetchComponentData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="print_chat">
        <b-button
          variant="primary"
          @click="printChat"
          >Print Report</b-button>
      </div>
    <div class="row chat_filter">
      <div class="col-md-12">
        <div class="row">
          <!-- Select Admin -->
          <div class="col-md-4 select_admin">
            <label>Select Admin</label>
            <select
              class="custom-select custom-select-sm"
              v-model="selectedAdmin"
              @change="onChangeSelect($event)"
            >
              <option value="null">
                All
              </option>
              <option v-for="(item, i) in adminList" v-bind:value="item.id" :key="i">
                
                {{ item.name }}
              </option>
            </select>
          </div>
          <!-- /Select Admin -->
          <!-- Start Date -->
          <div class="col-md-4 form-group mb-3">
            <b-form-group
              id="label-date"
              label-cols-sm="3"
              label-cols-lg="3"
              label="Start Date"
              label-for="start-date"
            >
              <b-form-input id="start-date" v-model="start_date" @change="onChangeSelect($event)" value="2019-08-19" type="date">
              </b-form-input>
            </b-form-group>
          </div>
          <!-- End Date -->
          <div class="col-md-4 form-group mb-3">
            <div class="form-group mb-3">
              <b-form-group
                id="label-end-date"
                label-cols-sm="3"
                label-cols-lg="3"
                label="End Date"
                label-for="end-date"
              >
                <b-form-input id="end-date" v-model="end_date" @change="onChangeSelect($event)"  value="2019-08-19" type="date">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Cards -->
    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">Average Time To Start</p>
                <h4 class="mb-0">
                  <ICountUp
                    :delay="delay"
                    :endVal="startAverageTime"
                    :options="options"
                  />
                  <div class="unit">Minutes</div>
                </h4>
              </div>
              <div class="text-primary">
                <i class="ri-numbers-line font-size-24"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- average time to respond  -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">
                  Average Time To Respond For Agent
                </p>
                <h4 class="mb-0">
                  <ICountUp
                    :delay="delay + 100"
                    :endVal="respondAverageTimeAgent"
                    :options="options"
                  />
                  <div class="unit">Minutes</div>
                </h4>
              </div>
              <div class="text-primary">
                <i class="ri-numbers-line font-size-24"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- total -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">
                  Average Time To Respond For User
                </p>
                <h4 class="mb-0">
                  <ICountUp
                    :delay="delay + 100"
                    :endVal="respondAverageTimeUser"
                    :options="options"
                  />
                  <div class="unit">Minutes</div>
                </h4>
              </div>
              <div class="text-primary">
                <i class="ri-numbers-line font-size-24"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- total -->
      <!-- last week users -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">Average Time To End</p>
                <h4 class="mb-0">
                  <ICountUp
                    :delay="delay + 200"
                    :endVal="endAverageTime"
                    :options="options"
                  />
                  <div class="unit">Minutes</div>
                </h4>
              </div>
              <div class="text-primary">
                <i class="ri-numbers-line font-size-24"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">Total</p>
                <h4 class="mb-0">
                  <ICountUp :delay="delay + 100" :endVal="total" :options="options" />
                  <div class="unit">Sessions</div>
                </h4>
              </div>
              <div class="text-primary">
                <i class="ri-numbers-line font-size-24"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- total -->
      <!-- total -->
      <!-- /Cards -->
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <!-- Limit & search -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions">
                    </b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="filter"
                      @input="fetchAdminList"
                      type="search"
                      placeholder="Search ..."
                      class="form-control form-control-sm ml-2"
                    >
                    </b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="mb-0">
              <b-table
                primary-key="id"
                :tbody-transition-props="transProps"
                :items="componentData"
                :fields="fields"
                :hover="hover"
                responsive="sm"
                :per-page="0"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(actions)="row">
                  <div class="d-inline">
                    <b-button
                      size="sm"
                      @click="viewItem(row.item, $event.target, viewRouteName)"
                      class="mr-1"
                      v-b-tooltip.hover
                      title="view"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </div>
                  <ConfirmDelete
                    :row="row"
                    :deleteItem="deleteItem"
                    :deleteLink="deleteLink"
                    :fetchComponentData="fetchComponentData"
                    permissionName="delete_admin"
                  ></ConfirmDelete>
                </template>
              </b-table>
              <div class="table_feedback">
                <div
                  class="empty_records text-center"
                  v-if="componentData.length == 0 && !isBusy"
                >
                  <p>There are no records to show.</p>
                </div>
                <div class="empty_filtered text-center" v-if="rows > 0 && totalRows == 0">
                  <p>There are no records matching your request.</p>
                </div>
                <div class="loading" v-if="isBusy">
                  <Loading></Loading>
                </div>
              </div>
              <!-- table_feedback -->
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      @input="fetchAdminList"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
  </Layout>
</template>
<style scoped>
.select_admin label {
  display: inline-block;
}

div.unit {
  display: inline-flex;
  position: absolute;
  right: 2%;
  font-size: 1rem;
  bottom: 20%;
  color: #5664d2;
}
.chat_filter {
  padding-top: 1rem;
  border-top: 1px solid #2d3448;
  margin-bottom: 0rem;
}
.print_chat {
  margin-bottom: 1rem;
  position: absolute;
  top: 6rem;
  right: 1rem;
}
.print_chat .btn {
  padding: 0.47rem 4rem;
}
.chat_filter label,
label.col-form-label {
  width: 30%;
  display: inline-block;
}

select {
  display: inline-block;
  width: 68%;
  height: 38px;
}
input.form-control {
  display: inline-block;
  width: 98%;
}
</style>
